import { api } from '../../../shared/api/client';

export const login = (data) => api.post('auth/login', data);
export const logout = () => api.post('auth/logout', {});
export const verify = (deviceId, otp) => api.post('/auth/verify', { deviceId, otp });
